import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Button,
    Card,
    Container,
    Grid,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
// sections
// mock
import moment from 'moment';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ComboboxImage from 'src/components/Input/ComboboxImage';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { FormatNumber, glb_sv, sendRequest, serviceList } from 'src/utils';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ExportStaticstical() {
    const params = useParams();
    const [visibleDel, setVisibleDel] = useState(false);
    const arrFillters = useRef([]);
    const { t } = useTranslation();
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [cabinet, setcabinet] = useState({ cabinet_nm: t('all'), id: 0 });
    const [startDay, setstartDay] = useState(moment().startOf('month').format('YYYYMMDDHHmmss'));
    const [toDay, settoDay] = useState(moment().format('YYYYMMDDHHmmss'));

    const [dataCabinet, setDataCabinet] = useState([]);
    const getRef = useRef(false);
    const tableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: `${t('export_inventory')} ${glb_sv.formatDate(startDay, 'YYYYMMDDHHmmss')} - ${glb_sv.formatDate(
            toDay,
            'YYYYMMDDHHmmss'
        )}`,
        sheet: t('export_inventory'),
    });

    const TABLE_HEAD = [
        { id: 'Thao tác', label: 'STT', alignRight: false },
        { id: 'name', label: t('code_device'), alignRight: false },
        { id: 'company', label: t('name_device'), alignRight: false },
        { id: 'company', label: t('name_cabinet'), alignRight: false },
        { id: 'role', label: t('ton_dau'), alignRight: false },
        { id: 'role', label: t('du_dau'), alignRight: false },
        { id: 'role', label: t('sl_nhap'), alignRight: false },
        { id: 'role', label: t('money_import'), alignRight: false },
        { id: 'role', label: t('quanty_export'), alignRight: false },
        { id: 'role', label: t('money_export'), alignRight: false },
        { id: 'role', label: t('ton_cuoi'), alignRight: false },
        { id: 'role', label: t('du_cuoi'), alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, [startDay, toDay, cabinet]);

    useEffect(() => {
        setTimeout(() => {
            getDataCabinet();
        }, 1000);
    }, []);

    const getDataCabinet = useCallback(() => {
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 40000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCabinet([{ cabinet_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
        }
    };
    const timeOutFunctCabinet = (reqInfo) => {};

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [startDay, toDay, cabinet?.id ? cabinet.id : 0];
        sendRequest(serviceList.getStocking, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [startDay, toDay, cabinet]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = tableData.map((n) => n.supplier_nm);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleDelete = () => {
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [startDay, toDay];
        sendRequest(serviceList.insertStatisticChecking, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            onDownload();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    let sum = {
        ton_dau: 0,
        du_dau: 0,
        sl_nhap: 0,
        tien_nhap: 0,
        sl_xuat: 0,
        tien_xuat: 0,
        ton_cuoi: 0,
        du_cuoi: 0,
    };
    return (
        <>
            <Helmet>
                <title> {t('quan_ly_bo_phan')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('export_inventory')}
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={handleDelete}>
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                <Breadcrumb
                    paths={[
                        {
                            label: t('lock_repoet'),
                            url: `/home/statictical-check/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('export_inventory'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <Loader loading={deleleFlags} />
                <Card>
                    <Grid container spacing={2} padding={2}>
                        <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                datetime
                                valueChange={startDay}
                                getValue={setstartDay}
                            />
                        </Grid>
                        <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue label={t('to_day')} datetime valueChange={toDay} getValue={settoDay} />
                        </Grid>
                        <Grid item xl={4} md={4} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboboxImage
                                label={t('choose_cabinet')}
                                sizeCbb="medium"
                                getValue={setcabinet}
                                valueSelect={cabinet}
                                displayImage="img_cabinet"
                                selectOption={dataCabinet?.filter((ele) => ele.block_status === '1')}
                                displayLabel="cabinet_nm"
                                autoFocus
                            />
                        </Grid>
                    </Grid>
                    <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />

                    {/* <Scrollbar> */}
                    <TableContainer sx={{}}>
                        <Table ref={tableRef}>
                            <DepartmentListHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                                numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                                onSelectAllClick={handleSelectAllClick}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        sum = {
                                            ton_dau: (sum.ton_dau += item.ton_dau),
                                            du_dau: (sum.du_dau += item.du_dau),
                                            sl_nhap: (sum.sl_nhap += item.nhap_filter),
                                            tien_nhap: (sum.tien_nhap += item.gia_nhap_filter),
                                            sl_xuat: (sum.sl_xuat += item.xuat_filter),
                                            tien_xuat: (sum.tien_xuat += item.gia_xuat_filter),
                                            ton_cuoi: (sum.ton_cuoi += item.ton_cuoi),
                                            du_cuoi: (sum.du_cuoi += item.du_cuoi),
                                        };
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                                tabIndex={-1}
                                                role="checkbox"
                                                // selected={selectedUser}
                                            >
                                                <TableCell padding="checkbox"></TableCell>

                                                <TableCell align="left">{index + 1}</TableCell>
                                                <TableCell align="left">{item.device_cd}</TableCell>

                                                <TableCell align="left">
                                                    {glb_sv.convertMultipleLanguages(item.device_nm)}
                                                </TableCell>
                                                <TableCell align="left">{item?.cabinet_nm}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.ton_dau)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.du_dau)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.nhap_filter)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.gia_nhap_filter)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.xuat_filter)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.gia_xuat_filter)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.ton_cuoi)}</TableCell>
                                                <TableCell align="left">{FormatNumber(item.du_cuoi)}</TableCell>

                                                {/* <TableCell padding="checkbox"></TableCell> */}
                                            </TableRow>
                                        );
                                    })}
                                <TableRow
                                    hover
                                    tabIndex={-1}
                                    role="checkbox"
                                    // selected={selectedUser}
                                >
                                    <TableCell padding="checkbox"></TableCell>
                                    <TableCell padding="checkbox"></TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {t('sum')}
                                    </TableCell>
                                    <TableCell padding="checkbox"></TableCell>

                                    <TableCell padding="checkbox"></TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.ton_dau)}
                                    </TableCell>

                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.du_dau)} vnđ
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.sl_nhap)}
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.tien_nhap)} vnđ
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.sl_xuat)}
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.tien_xuat)} vnđ
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.ton_cuoi)}
                                    </TableCell>
                                    <TableCell padding="checkbox" sx={{ fontWeight: '600' }}>
                                        {FormatNumber(sum.du_cuoi)} vnđ
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* </Scrollbar> */}
                </Card>
            </Container>
        </>
    );
}
